import {Constants} from './constants.types';

const constants: Constants = {
  breakpoints: {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1920,
  },
}

export default constants;
